import { render, staticRenderFns } from "./UpdatedCartItems.vue?vue&type=template&id=3e1d4132&"
import script from "./UpdatedCartItems.vue?vue&type=script&lang=js&"
export * from "./UpdatedCartItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports